import * as builders from './builders';

export const translateContentToProps = content => {
  let questionType;
  if (
    content.component === 'flagship_ab_test' ||
    content.question?.[0].component === 'flagship_ab_test'
  ) {
    questionType = content.question?.[0].variants[0]?.blocks[0]?.component;
  } else {
    questionType = content.question?.[0].component ?? content.component;
  }
  // eslint-disable-next-line import/namespace
  const builder = builders[questionType];
  return builder.validateSync(content);
};
